import * as SignalR from '@aspnet/signalr'

export default {
  createHub (token) {
    return new SignalR.HubConnectionBuilder()
      .withUrl("https://iDrive42.ru:8088/chat/", {
        accessTokenFactory: ()=> {
          return token
        },
        skipNegotiation: true,
        transport: SignalR.HttpTransportType.WebSockets
      })
      .configureLogging(SignalR.LogLevel.Debug)
      .build()
  }
}

